// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"style__callToAction__jNwvT"};